/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockAdjustInitResVo } from './AdminStockAdjustInitResVo';
import {
    AdminStockAdjustInitResVoFromJSON,
    AdminStockAdjustInitResVoFromJSONTyped,
    AdminStockAdjustInitResVoToJSON,
    AdminStockAdjustInitResVoToJSONTyped,
} from './AdminStockAdjustInitResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockAdjustInitResVo
 */
export interface ResponseAdminStockAdjustInitResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockAdjustInitResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockAdjustInitResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockAdjustInitResVo}
     * @memberof ResponseAdminStockAdjustInitResVo
     */
    data?: AdminStockAdjustInitResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockAdjustInitResVo interface.
 */
export function instanceOfResponseAdminStockAdjustInitResVo(value: object): value is ResponseAdminStockAdjustInitResVo {
    return true;
}

export function ResponseAdminStockAdjustInitResVoFromJSON(json: any): ResponseAdminStockAdjustInitResVo {
    return ResponseAdminStockAdjustInitResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockAdjustInitResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockAdjustInitResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockAdjustInitResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockAdjustInitResVoToJSON(json: any): ResponseAdminStockAdjustInitResVo {
    return ResponseAdminStockAdjustInitResVoToJSONTyped(json, false);
}

export function ResponseAdminStockAdjustInitResVoToJSONTyped(value?: ResponseAdminStockAdjustInitResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockAdjustInitResVoToJSON(value['data']),
    };
}

